import { Box, IconButton, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import "../features/main-page/views/MainPage.css";

export const SignInRegisterButtons = () => {
  const navigate = useNavigate();

  const handleNavigateToSignIn = () => {
    navigate("/account/login");
  };

  const handleNavigateToRegister = () => {
    navigate("/account/register");
  };

  return (
    <Box
      className={`signin-register-container ${window.location.href.includes("suites") && "suites-view"}`}
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        gap: "1rem",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 1rem 0 0",
      }}
    >
      <IconButton
        className="signin-action-button"
        onClick={handleNavigateToSignIn}
      >
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "24px",
          }}
        >
          Sign In
        </Typography>
      </IconButton>

      <IconButton
        className="register-action-button"
        onClick={handleNavigateToRegister}
      >
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: 500,
            lineHeight: "24px",
          }}
        >
          Register
        </Typography>
      </IconButton>
    </Box>
  );
};
